namespace Areas.Transmittal.Detail {
    "use strict";

    let currentTransmittalId: number = 0;
    let runQuery: boolean = false;

    export function addTransmittalGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        let visibleButton = grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "transmittal" },
            text: "Copy Transmittal",
            hint: "Copy",
            type: "default",
            icon: "add",
            visible: visibleButton,
            onClick: copyTransmittal
        }, "before");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "transmittal" },
            text: "Email Transmittal",
            hint: "Email",
            type: "default",
            icon: "email",
            visible: visibleButton,
            onClick: emailTransmittal
        }, "before");
    }

    export function copyTransmittal() {
        const dataGrid = $("#TransmittalGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();
      
        if (selectedRows.length) {
            const id = selectedRows[0].transmittalId;
            const url = `/Transmittal/Detail/CopyTransmittal/${id}`;

            sendRequest(url, "", "POST", () => {
                dataGrid.refresh();
                dataGrid.selectRowsByIndexes([0]);
            });
        }

    }

    export function emailTransmittal() {
        const dataGrid = $("#TransmittalGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows.length) {
            const id = selectedRows[0].transmittalId;
            const url = `/Transmittal/Detail/EmailTransmittal/${id}`;

            sendRequest(url, "", "POST", () => {
                dataGrid.refresh();
                dataGrid.selectRowsByIndexes([0]);
            });
        }

    }

    export function getTransmittalId() {
        return currentTransmittalId;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onNewTransmittalDetailRow(e: any) {
        const data = e.data;
        data.transmittalId = currentTransmittalId;
    }

    export function onTransmittalGridSelectionChanged(e: any) {
        let selectedRows = e.component.getSelectedRowsData();
        let detailGrid: any = $("#TransmittalDetailGrid").dxDataGrid("instance");

        if (selectedRows.length === 1) {
            runQuery = true;
            currentTransmittalId = selectedRows[0].transmittalId;
            detailGrid.option("disabled", false);
            Areas.refreshGrid("TransmittalDetailGrid");

        } else {
            detailGrid.option("disabled", true);
        }
    }    

    export function onTransmittalNew(e: any) {
        const grid: any = $("#TransmittalGrid").dxDataGrid("instance");
        const transmittalProfileId = grid.option("TransmittalProfileId");

        e.data.transmittalProfileId = transmittalProfileId;
        currentTransmittalId = 0;
        setBooleanProperties(e.data);
    }

    function setBooleanProperties(data: any) {
        const booleanProperties = [
            "isShopDrawing",
            "isLetter",
            "isChangeOrder",
            "isPlans",
            "isSamples",
            "isForApproval",
            "isForYourUse",
            "isAsRequested",
            "isForReview",
            "isAttached",
            "isSeparateCover",
            "isAsSubmitted",
            "isAsNoted",
            "isApprovedNotedResubmit",
            "isRevisedResubmitted",
            "isSubmit",
            "isReturned",
            "isForCorrections"
        ];
    
            booleanProperties.forEach(property => {
                data[property] = false;
            });

    }

    interface ITextEditorDictionary {
        [index: string]: DevExpress.ui.dxTextBox;
    }

    const textEditorDictionary = {} as ITextEditorDictionary;

    export function onTransmittalEditorPrepared(e: any) {
        const fieldNames: Array<string> = [
            "fromCompany",
            "fromContactName",
            "toCompany",
            "toContactName"
        ];

        if (e.parentType === "dataRow" && fieldNames.indexOf(e.dataField) > -1) {
            const editor: DevExpress.ui.dxTextBox = e.editorElement.dxTextBox('instance');
            textEditorDictionary[e.dataField] = editor;
        }
    }

    export function onTransmittalEditPopupShowing(e: any) {
        const items = e.component.option("toolbarItems");

        const saveButtonIndex = 0;
        const cancelButtonIndex = 1;
        const saveButton = items[saveButtonIndex];
        const cancelButton = items[cancelButtonIndex];

        const grid: any = $("#TransmittalGrid").dxDataGrid("instance");
        
        cancelButton.options.elementAttr = { class: "cancel" };
        cancelButton.options.icon = "revert";
        cancelButton.options.onClick = (e) => {
            grid.cancelEditData();
            grid.setMode(Areas.GridMode.Normal);
        };

        saveButton.options.type = "success";
        saveButton.options.icon = "save";
        saveButton.options.onClick = (e) => {
            grid.saveEditData();
            grid.setMode(Areas.GridMode.Normal);
        }
        
        e.component.option("toolbarItems", items);
    }

    export function selectFromContact() {
        const grid: any = $("#TransmittalGrid").dxDataGrid("instance");
        const parameters = { accountId: grid.option("AccountId") };

        const accountTeamLookupDialog = 
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("from"), parameters);
    }

    export function selectToContact() {
        const grid: any = $("#TransmittalGrid").dxDataGrid("instance");
        const parameters = { accountId: grid.option("AccountId") };

        const accountTeamLookupDialog = 
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(accountTeamDialogClosing("to"), parameters);
    }    

    function accountTeamDialogClosing(fromOrTo: string) {
        return (dialogResult: DialogResult, data: any) => {
            if (dialogResult === DialogResult.Cancel) return;
    
            const grid: any = $("#TransmittalGrid").dxDataGrid("instance");
            const rowIndex = getRowIndex(grid);

            if (fromOrTo === "from") {
                setTextBoxValue(textEditorDictionary["fromCompany"], data.companyName);
                setTextBoxValue(textEditorDictionary["fromContactName"], data.displayName);
                grid.cellValue(rowIndex, "fromContactId", data.contactId);
            } else {
                setTextBoxValue(textEditorDictionary["toCompany"], data.companyName);
                setTextBoxValue(textEditorDictionary["toContactName"], data.displayName);
                grid.cellValue(rowIndex, "toContactId", data.contactId);
            }
        } 
    } 
    
    function setTextBoxValue(textBox:DevExpress.ui.dxTextBox, value: string) {
        textBox.option("value", value);
    }
    
    function getRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentTransmittalId === 0) {
            return rowIndex;
        } else  {
            rowIndex = dataGrid.getRowIndexByKey(currentTransmittalId);
        }

        return rowIndex;
    }    

}